<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2><span>The inspection was lasting :</span></h2>
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--subheader">
            <td style="width: 20%">
              <span>Date :</span>
            </td>
            <td style="width: 20%">
              <span>Hour(s)</span>
            </td>
            <td style="width: 20%">
              <span>Minute(s)</span>
            </td>
          </tr>
          <tr
            class="th-plugin-line--input"
            formArrayName="timesheets"
            *ngFor="let item of formData.controls; let i = index"
          >
            <td style="width: 20%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input formControlName="Date" class="ir-form-set" type="date" />
              </div>
            </td>
            <td style="width: 20%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input formControlName="Hours" placeholder="00" class="ir-form-set" type="number" />
              </div>
            </td>
            <td style="width: 20%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input formControlName="Minutes" placeholder="00" class="ir-form-set" type="number" min="0" max="59" />
              </div>
            </td>
            <td class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>Cancel</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!editForm.valid"
            *ngIf="!processing"
          >
            <span>Save changes</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'Delete confirmation'"
  [message]="'Are you sure to delete this <strong>plugin</strong> ?'"
  [danger]="true"
></confirm>
